/**
 * Was beim Speichern unter einem Betragsfeld steht, gleich in allen
 * Formularen.
 *
 * Audit Oktober 2026 (FIN-1 bis 3): Kontostand, Mindestpuffer und Kredit
 * lasen ihre Felder mit `.replace(',', '.')`. „190.000“ wurde so zu 190 €,
 * „190.000,50“ zu einem 422, beides still. Seit D1 liest das `Betragsfeld`
 * aus @elbklar/ui und gibt einen Decimal-Text oder `null` (keine Zahl); hier
 * bleibt nur, das beim Speichern zu sagen.
 */

export function betragFehler(
  dezimal: string | null,
  {
    leerErlaubt = false,
    nichtNull = false,
    nurPositiv = false,
  }: {
    leerErlaubt?: boolean;
    nichtNull?: boolean;
    /**
     * Für Felder ohne Auswahl „Richtung“ (erwarteter Zufluss aus dem Radar):
     * Ein Minus ist dort ein Tippfehler. Still das Vorzeichen zu streichen
     * (`ohneVorzeichen`) machte aus „-5000“ einen Zufluss (Gegenprüfung D2).
     */
    nurPositiv?: boolean;
  } = {}
): string | undefined {
  if (dezimal === null) return 'Das ergibt keine Zahl. Beispiele: 190000, 190.000,50 oder 3000*1,19';
  if (dezimal === '') return leerErlaubt ? undefined : 'Betrag fehlt';
  if (nichtNull && Number(dezimal) === 0) return 'Der Betrag ist 0';
  if (nurPositiv && Number(dezimal) < 0) return 'Nur positive Beträge';
  return undefined;
}

/** Ein Decimal-Text ohne Vorzeichen: Das Vorzeichen trägt die Auswahl „Richtung“. */
export function ohneVorzeichen(dezimal: string): string {
  return dezimal.replace(/^-/, '');
}
